export class AvatarHelper {
  private static BASE_URL = import.meta.env.VITE_API_BASE_URL || ''

  /**
   * 获取完整的头像URL
   * @param avatarPath 头像路径，可能是相对路径或完整URL
   * @returns 完整的头像URL，如果无头像则返回null
   */
  static getAvatarUrl(avatarPath?: string | null): string | null {
    if (!avatarPath) return null
    
    // 如果已经是完整URL，直接返回
    if (avatarPath.startsWith('http') || avatarPath.startsWith('https')) {
      return avatarPath
    }
    
    // 如果是相对路径，拼接base URL
    // 规范化 BASE_URL 和 avatarPath 的斜杠
    const base = this.BASE_URL.endsWith('/') 
        ? this.BASE_URL.slice(0, -1) 
        : this.BASE_URL;
    const path = avatarPath.startsWith('/') 
        ? avatarPath 
        : `/${avatarPath}`;
      
    return `${base}${path}`;
  }

  /**
   * 获取默认头像的首字母
   * @param firstName 名字
   * @param lastName 姓氏
   * @returns 首字母组合
   */
  static getInitials(firstName?: string, lastName?: string): string {
    const first = firstName?.charAt(0)?.toUpperCase() || ''
    const last = lastName?.charAt(0)?.toUpperCase() || ''
    return first + last || '用户'
  }

  /**
   * 验证头像文件
   * @param file 要验证的文件
   * @returns 验证结果对象
   */
  static validateAvatarFile(file: File): { valid: boolean; message?: string } {
    // 检查文件大小 (最大12MB)
    if (file.size > 12 * 1024 * 1024) {
      return { valid: false, message: '文件大小不能超过12MB' }
    }

    // 检查文件类型
    if (!file.type.startsWith('image/')) {
      return { valid: false, message: '请选择图片文件' }
    }

    // 检查支持的图片格式
    const supportedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp']
    if (!supportedTypes.includes(file.type)) {
      return { valid: false, message: '支持的图片格式：JPG、PNG、GIF、WebP' }
    }

    return { valid: true }
  }

  /**
   * 获取头像颜色（基于用户名生成）
   * @param firstName 名字
   * @param lastName 姓氏
   * @returns 颜色类名
   */
  static getAvatarColor(firstName?: string, lastName?: string): string {
    const name = `${firstName || ''}${lastName || ''}`
    const colors = [
      'bg-red-500', 'bg-blue-500', 'bg-green-500', 'bg-yellow-500',
      'bg-purple-500', 'bg-pink-500', 'bg-indigo-500', 'bg-teal-500'
    ]
    
    let hash = 0
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash)
    }
    
    return colors[Math.abs(hash) % colors.length]
  }
} 